import { useCallback } from 'react'
import {
  ApiDeleteWithToken,
  ApiGetWithToken,
  ApiPatchWithToken,
  ApiPostWithToken,
  useApiFetch,
  useApiPost
} from 'shared/api'
import { evaluationFormApi, evaluationFormApiBy } from 'interface/endpoints'
import { EvaluationFormData, EvaluationFormResult, EvaluationFormListResult } from './types'

export * from './types'

export const useGetEvaluationForm = (
  formId?: number | null
) => useApiFetch(
  useCallback(
    (apiAccess, cancelToken) => {
      if (!formId) return null
      return ApiGetWithToken<EvaluationFormResult>(
        apiAccess,
        evaluationFormApiBy(formId),
        cancelToken
      )
    },
    [formId]
  )
)

export const useListEvaluationForm = () => useApiFetch(
  useCallback(
    (apiAccess, cancelToken) => {
      return ApiGetWithToken<EvaluationFormListResult>(
        apiAccess,
        evaluationFormApi('/list'),
        cancelToken
      )
    },
    []
  )
)

export const usePostEvaluationForm = (
  callback?: {
    onPosted?: (result: EvaluationFormResult) => void
    onError?: (reason: Error | undefined) => void
  }
) => useApiPost<EvaluationFormData, EvaluationFormResult>(
  useCallback(
    (apiAccess, cancelToken, form, webSocketId) => {
      return ApiPostWithToken(
        apiAccess,
        evaluationFormApi(),
        form,
        cancelToken,
        webSocketId
      )
    },
    []
  ),
  useCallback(
    (result) => {
      if (callback?.onPosted) callback.onPosted(result)
      return result
    },
    [callback]
  ),
  useCallback(
    (reason) => {
      if (callback?.onError) callback?.onError(reason)
    },
    [callback]
  )
)

export const useEditEvaluationForm = (
  formId: number, 
  callback?: {
    onEditted?: (result: EvaluationFormResult) => void
    onError?: (reason: Error | undefined) => void
  }
) => useApiPost<EvaluationFormData, EvaluationFormResult>(
  useCallback(
    (apiAccess, cancelToken, form, webSocketId) => {
      return ApiPatchWithToken(
        apiAccess,
        evaluationFormApiBy(formId),
        form,
        cancelToken,
        webSocketId
      )
    },
    [formId]
  ),
  useCallback(
    (result) => {
      if (callback?.onEditted) callback.onEditted(result)
      return result
    },
    [callback]
  ),
  useCallback(
    (reason) => {
      if (callback?.onError) callback?.onError(reason)
    },
    [callback]
  )
)

export const useDeleteEvaluationForm = (
  callback?: {
    onDeleted?: (formId: number) => void
    onError?: (reason: Error | undefined) => void
  }
) => useApiPost<number, number>(
  useCallback(
    (apiAccess, cancelToken, formId, webSocketId) => {
      return ApiDeleteWithToken(
        apiAccess,
        evaluationFormApiBy(formId),
        cancelToken,
        webSocketId
      )
    },
    []
  ),
  useCallback(
    (result) => {
      if (callback?.onDeleted) callback.onDeleted(result)
      return result
    },
    [callback]
  ),
  useCallback(
    (reason) => {
      if (callback?.onError) callback?.onError(reason)
    },
    [callback]
  )
)

